import React, { useEffect, useMemo, useState } from 'react'
import { Form, Formik } from 'formik'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { defaultFulfillmentCenterTypeFilters } from 'src/features/fulfillmentCenterFilters'
import { actions as appActions } from 'src/features/state'
import { selectFulfillmentCenters } from 'src/features/selector'
import { useSelector } from 'src/utils/store'
import { getReceivements } from 'src/services/receivement/receivementService'
import { getSuppliers } from 'src/services/suppliers/suppliersService'
import Button from 'src/components/Button'
import Loading from 'src/components/Loading'
import Table from 'src/components/Table'
import Text from 'src/components/Text'
import * as S from './ReceivementList.styles'

const ReceivementList = () => {
  const defaultFCSelected = { label: 'TODOS', value: 'TODOS', id: null }
  const dispatch = useDispatch()
  const [receivements, setReceivements] = useState([])
  const [suppliers, setSuppliers] = useState([])
  const [supplier, setSupplier] = useState({})
  const [loading, setLoading] = useState(false)
  const [FC, setFC] = useState(defaultFCSelected)
  const fulfillmentCenters = useSelector(selectFulfillmentCenters)

  const FCs = useMemo(() => [
    defaultFCSelected,
    ...fulfillmentCenters.map(({ id, name }) => ({ label: name, value: name, id })),
  ], [fulfillmentCenters])

  const getSuppliersList = async () => {
    const result = await getSuppliers()
    if (!result.isOk) {
      toast.error('Falha ao carregar fornecedores!')
      return
    }
    const newSuppliers = result.data.fornecedores.map(({ nm_fornecedor, id_fornecedor }) => (
      { label: nm_fornecedor, value: id_fornecedor }
    ))
    setSuppliers(newSuppliers)
  }

  useEffect(() => {
    if (fulfillmentCenters.length === 0) {
      dispatch(appActions.getAvailableFulfillmentCenters(defaultFulfillmentCenterTypeFilters))
    }
  }, [dispatch, fulfillmentCenters.length])

  useEffect(() => {
    getSuppliersList()
  }, [])

  const handleChangeFC = ({ label, value, id }) => {
    setFC({ label, value, id })
  }

  const handleSubmit = async ({dateFrom, dateTo}) => {
    setLoading(true)

    const fcId = FC?.id || ''
    const supplierValue = supplier?.value || ''

    const result = await getReceivements(dateFrom, dateTo, supplierValue, fcId)
    if (!result.isOk) {
      toast.error('Falha ao carregar recebimentos!')
      setReceivements([])
      setLoading(false)
      return
    }
    setReceivements(result.data.recebimentos)
    setLoading(false)
  }

  return (
    <>
      <S.ReceivementListContainer>
        <Text textType="header" text="receivementList" />
        <Formik
          initialValues={{
            dateFrom: '',
            dateTo: '',
            fc: ''
          }}
          onSubmit={values => { handleSubmit(values) }}
        >
          <Form style={{ marginTop: '40px' }}>
            <S.FormContainer>
              <S.OptionContainer>
                <S.OptionLabel htmlFor="dateFrom">Data de:</S.OptionLabel>
                <S.DateSelect required type="date" id="dateFrom" name="dateFrom" />
              </S.OptionContainer>
              <S.OptionContainer>
                <S.OptionLabel htmlFor="dateTo">Data até:</S.OptionLabel>
                <S.DateSelect required type="date" id="dateTo" name="dateTo" />
              </S.OptionContainer>
              <S.ContainerSelect>
                <S.OptionLabel htmlFor="supplier">Fornecedor:</S.OptionLabel>
                <Select options={suppliers} value={supplier} onChange={(value) => setSupplier(value)} id="supplier" isClearable="true" name="supplier" />
              </S.ContainerSelect>
              <S.ContainerSelect>
                <S.OptionLabel htmlFor="fc">FC:</S.OptionLabel>
                <Select required options={FCs} value={FC} onChange={(value) => handleChangeFC(value)} id="fc" name="fc" />
              </S.ContainerSelect>
              <Button text="receivement.form.filter" type="submit" style={{ height: '40px', marginTop: '20px' }} />
            </S.FormContainer>
          </Form>
        </Formik >
        <S.TableContainer>
          <Table
            headers={[
              { name: 'FC', label: 'FC' },
              { name: 'collaborator', label: 'receivement.table.header.collaborator' },
              { name: 'invoice', label: 'receivement.table.header.invoice' },
              { name: 'supplier', label: 'receivement.table.header.supplier' },
              { name: 'receivementDate', label: 'receivement.table.header.receivementDate' },
            ]}
            initData={receivements.map((receivement) => ({
              FC: receivement.fulfillment_center.name,
              collaborator: receivement.usuario,
              invoice: receivement.nota_fiscal,
              supplier: receivement.fornecedor,
              receivementDate: receivement.data_recebimento,
            }))}
            style={{ marginTop: '12px' }}
          />
        </S.TableContainer>
      </S.ReceivementListContainer>
      <Loading loading={loading} style={{ opacity: '0.6' }}></Loading>
    </>
  )
}
export default ReceivementList
